<template lang="pug">
  svg.svg-example-mix(:width="width" :height="height")
    g#counter(:transform="counterTransform")
      SvgSprite(:rect="{ x: 0, width: 50, height: 300 }" id="butter-melted")
      SvgSprite(:rect="{ x: 55, width: 41, height: 300 }" id="sugar")
      SvgSprite(:rect="{ x: 101, width: 45, height: 300 }" id="sour-cream")
      SvgSprite(:rect="{ x: 151, width: 17.5, height: 300 }" id="egg")
      SvgSprite(:rect="{ x: 173.5, width: 69, height: 300 }" id="milk")
</template>

<script>
import SvgSprite from '../SvgSprite.vue';

export default {
  name: 'svg-example-mix',
  components: {
    SvgSprite,
  },

  props: {
    width: Number,
    height: Number,
    counterX: {
      type: Number,
      default: 650,
    },
  },

  computed: {
    counterTransform() {
      const counterBoxY = this.height - 325 - 300;
      return `translate(${this.counterX} ${counterBoxY})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-example-mix {
}
</style>
